import { Stack } from '@fluentui/react';
import { FluentProvider, webLightTheme, SkeletonItem } from '@fluentui/react-components';
import { dashboardTheme, notificationPosition, skeleton7 } from '../../styles/customStyles';

// Define the valid sizes as a type
type ValidSkeletonSize = 16 | 24 | 32 | 40 | 48 | 64 | 96 | 128;

// Define props interface
interface DynamicSkeletonProps {
    count?: number;
    size?: ValidSkeletonSize;
    gap?: number;
    style?: React.CSSProperties;
    containerStyle?: React.CSSProperties;
}

export const DynamicSkeleton = ({
    count = 7,
    size = 16,
    gap = 15,
    style = {},
    containerStyle = {}
}: DynamicSkeletonProps) => {
    return (
        <FluentProvider theme={dashboardTheme}>
            <Stack tokens={{ childrenGap: gap }} style={containerStyle}>
                {[...Array(count)].map((_, index) => (
                    <SkeletonItem
                        key={index}
                        size={size}
                        style={style}
                    />
                ))}
            </Stack>
        </FluentProvider>
    );
};

export default DynamicSkeleton;